import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyPagination,
	//MyButton,
	//MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Updatedlog 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaob  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	/*const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0);

	const [uDatamainObj,setDatamainObj]		= React.useState({})//-*/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	const uDatalogsArr	= [
		{version:"1.2.1",updated_arr:[
			{teks_menu:"Laporan >> Klinik >> Lap.Terapi",teks_content:"Update Fitur, Melengkapi Filter per Bulan per Terapi yang sebelumnya Tidak Aktif."},
		],tgl_updated:"2026-04-03"},
		{version:"1.2.0",updated_arr:[
			{teks_menu:"KLINIK >> Kasir >> Pembayaran Kasir",teks_content:"Update Fitur, Fitur Tambah-Edit-dan Hapus Item Terapi dihapus."},
			{teks_menu:"API >> Api2",teks_content:"Update Fitur, Upgrade Code untuk Framework Backend."},
		],tgl_updated:"2026-03-12"},
		{version:"1.1.0",updated_arr:[
			{teks_menu:"Helpers >> renderNota",teks_content:"Update Fitur, Menambahkan FEED Print Nota 5 Baris."},
		],tgl_updated:"2026-02-27"},
		{version:"1.0.1",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update Fitur, Load Data Card Fee Dokter dan Card Terapi dengan Rumus Pendapatan Terbaru."},
			{teks_menu:"Master Data >> Data Sistem >> Jenis Terapi",teks_content:"Update Fitur, Setting Master Data JENIS TERAPI."},
			{teks_menu:"Master Data >> Data Sistem >> Setting Terapi",teks_content:"Update Fitur, Setting Master Data Terapi untuk Penamaan, Harga Terapi dan Biaya-biaya."},
			{teks_menu:"Master Data >> Data Sistem >> Data Dokter",teks_content:"Update Fitur, Menambahkan Data Fee Spesialistik / Umum untuk Dokter."},
			{teks_menu:"Master Data >> Data Sistem >> Data Agama",teks_content:"Update Fitur, Setting Data Agama Pasien."},
			{teks_menu:"KLINIK >> Pasien >> Input Pasien Baru",teks_content:"Update Fitur, Tambah Lookup Input Agama Pasien.<br/>Tambah Kolom Nama Wilayah Administrasi untuk keperluan Pencarian Data Pasien."},
			{teks_menu:"KLINIK >> Kunjungan Pasien >> Status Kunjungan",teks_content:"Update Fitur, Form Screening Pasien dibuat Lookup Agama dan Pekerjaan secara Otomatis."},
			{teks_menu:"KLINIK >> Pasien >> Data Pasien",teks_content:"Update Fitur, Pencarian ADVANCED, berdasarkan Bulan Ulang Tahun, dan Wilayah Administrasi Pasien."},
			{teks_menu:"KLINIK >> Pasien >> Rekammedis",teks_content:"Update Fitur, Ubah Format Tampilan dengan SOAP.<br/>Perubahan Tampilan Detil, penambahan Navigasi Edit Odontogram."},
			{teks_menu:"KLINIK >> Pasien >> Rekammedis >> Edit Rekammedis",teks_content:"Update Fitur, Mengubah Metode Form Edit Rekammedis sesuai Input Billing yang baru."},
			{teks_menu:"KLINIK >> Pasien >> Rekammedis >> Billing Periksa",teks_content:"Update Fitur, Mengubah Input Billing menurut dengan metode SOAP.<br/>Mengubah Input Komponen Biaya Terapi sesuai Rumus yang telah ditentukan, termasuk Diskon Fixed dan Diskon Dokter.<br/>Menambahkan Fitur Odontogram."},
			{teks_menu:"KLINIK >> Kasir >> Pembayaran Kasir",teks_content:"Update Fitur, Mengubah Perhitungan Tarif Terapi sesuai Rumus, dan Diskon Total menjadi Diskon per Terapi."},
			{teks_menu:"KLINIK >> Kasir >> Rekap Nota",teks_content:"Update Fitur, Mengubah Perhitungan Tarif Terapi sesuai Rumus, dan Diskon Total menjadi Diskon per Terapi."},
			{teks_menu:"KLINIK >> Kasir >> Cetak Nota",teks_content:"Update Fitur, Mengubah Perhitungan Tarif Terapi sesuai Rumus, dan Diskon Total menjadi Diskon per Terapi."},
			{teks_menu:"API >> Api Kirim Satusehat",teks_content:"Update Fitur, Pengiriman satusehat Condition Diagnosa Utama dan Sekunder ICD10.<br/>Penambahan Pengiriman Modul Procedure ICD9-CM."},
			{teks_menu:"Laporan >> Operasional >> Laporan Kasir",teks_content:"Update Fitur, Format Kolom diubah menjadi sama dengan DEMO Terbaru."},
			{teks_menu:"Laporan >> Klinik >> Lap.Fee Dokter",teks_content:"Update Fitur, Format Kolom diubah menjadi sama dengan DEMO Terbaru."},
			{teks_menu:"Laporan >> Klinik >> Lap.Terapi",teks_content:"Update Fitur, Perubahan Format Laporan dengan Rincian Komponen Biaya yang Sudah Ditentukan."},
			{teks_menu:"Laporan >> Klinik >> Lap.Pasien",teks_content:"Update Fitur, Penambahan Laporan Pasien Baru dan Lama."},
			{teks_menu:"Laporan >> Klinik >> Lap.Reminder Terapi",teks_content:"Update Fitur, Penambahan Laporan Terapi Pasien dengan Kunjungan Terakhir 1 Tahun sebelumnya."},
		],tgl_updated:"2025-11-21"},
		{version:"0.0.1",updated_arr:[
			{teks_menu:"Aplikasi",teks_content:"Standar Aplikasi Dentalivo Default."},
		],tgl_updated:"2024-12-30"},
	]
	const uJmlData	= uDatalogsArr.length;

	//---HANDEL--/
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMain = () => {
		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);

		const vDataviewArr	= uDatalogsArr.slice(vMin,(vMax));

		return (
		<>
		{vDataviewArr.map((vItems,vKeys)=>{
			const vItemsArr	= vItems.updated_arr || [];

			return (
			<CCard className="mb-3 classbgcard" key={vKeys}>
			<CCardHeader className="d-flex justify-content-between">
				<div>Ver: <b>{vItems.version}</b></div>
				<div className="classfontsmaller"><small>{UFunc.HariAngka(vItems.tgl_updated)}</small></div>
			</CCardHeader>
			<CCardBody>
			<ul>
			{vItemsArr.map((vItemcontent,vKeycontent)=>{
				return (
				<li key={vKeycontent}>
					<div className="fw-bolder">{vItemcontent.teks_menu}</div>
					<small className="d-block fst-italic">{UFunc.renderHTML(vItemcontent.teks_content)}</small>
				</li>
				)//>
			})}
			</ul>
			</CCardBody>
			</CCard>
			)//>
		})}
		</>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = () => {}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
    	apiLoaddata();

    	return () => {
    		setPageActive(1);
    	}
	},[])
	//---END EFFECT--/

	//console.log("(Updatedlog) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-4 p-0">
		<CContainer fluid className="classheadertop border-bottom"
			style={{height:64}}>
			<CHeaderToggler className="px-0" onClick={()=>uNavigate(-1)}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>

			<CHeaderBrand className="me-auto">
				<small className="fw-bolder">
				Updated Logs<span className="d-none d-md-inline ms-1">{pjson.name}</span>
				</small>
			</CHeaderBrand>

			<CHeaderNav className="">
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-1 px-md-2 px-lg-5">
		<CContainer xxl className="px-0 mb-3">
			{contentMain()}

			{(uJmlData > uMaxData) && (
			<CCard>
			<CCardBody>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardBody>
			</CCard>
			)}
		</CContainer>
		</div>
		</div>
		</>
	)//>
}	

export default Updatedlog